export class ListSaasEntitiesRequestFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "SaasEntityTypeFilters",
            "format": ""
        },
        {
            "name": "search",
            "baseName": "search",
            "type": "string",
            "format": ""
        },
        {
            "name": "externalId",
            "baseName": "externalId",
            "type": "SaasEntityExternalIdFilters",
            "format": ""
        },
        {
            "name": "microsoft365",
            "baseName": "microsoft365",
            "type": "Microsoft365EntityFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSaasEntitiesRequestFilters.attributeTypeMap;
    }
    constructor() {
    }
}
